<div class="px-3 pb-3">
  <button
    type="button"
    class="btn btn-primary btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1 w-100 d-none"
    @click="redirect_to_proba"
  >
    Redirect to Proba
  </button>
</div>
